// export const loggedInRole = JSON.parse(
//   sessionStorage.getItem("usrlgndtls")
// )?.roleId;


export const loggedInRole = JSON.parse(
  sessionStorage.getItem("usrlgndtls")
)?.isAdmin;

export const loggedInId = JSON.parse(
  sessionStorage.getItem("usrlgndtls")
)?.userId;